import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { FAQS } from './salesData';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="bg-ivory py-12 sm:py-16" data-id="element-42" data-mp="1bmdali2zmwac">
      <div className="mx-auto max-w-2xl px-5" data-id="element-43" data-mp="1gkn3tn55jmtb">
        <h2 className="text-center font-display text-[1.7rem] font-semibold text-charcoal sm:text-[2.2rem]" data-id="element-44" data-mp="1glpw9zi4hxbc">
          Preguntas frecuentes
        </h2>

        <div className="mt-6 space-y-2" data-id="element-45" data-mp="289qa18gln78l">
          {FAQS.map((faq, i) => {
          const isOpen = open === i;
          return <div key={i} className="overflow-hidden rounded-xl border border-stone bg-sand/40" data-id="element-46" data-mp="1uhabokyn7xe0" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-3 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/50" data-id="element-47" data-mp="1zgd5tad34j77">
                  <span className="font-sans text-[0.88rem] font-semibold leading-snug text-charcoal sm:text-[0.95rem]" data-id="element-48" data-mp="14sxsphb5ggnq">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`h-4 w-4 shrink-0 text-gold-deep transition-transform ${isOpen ? 'rotate-180' : ''}`} aria-hidden data-id="element-49" data-mp="1emoicpj0ix50" />
                </button>
                <AnimatePresence initial={false} data-id="element-50" data-mp="1jj53rbytuxee">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} data-id="element-51" data-mp="1xkhi5iycaqy6">
                      <p className="px-4 pb-4 font-sans text-[0.82rem] leading-relaxed text-charcoal/70" data-id="element-52" data-mp="3ud18ec9ab1sh">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}